import React from 'react';
import './common.css';

/**
 * Component to display error messages
 * @param {Object} props - Component props
 * @param {string} props.message - Error message to display
 * @param {Function} props.onRetry - Optional callback for retry button
 */
function ErrorMessage({ message, onRetry }) {
  return (
    <div className="error-message">
      <div className="error-icon">
        <span className="icon-error">!</span>
      </div>
      <p>{message || 'An error occurred'}</p>
      {onRetry && (
        <button 
          type="button" 
          className="retry-button"
          onClick={onRetry}
        >
          Try Again
        </button>
      )}
    </div>
  );
}

export { ErrorMessage };
